// Shared helper for authenticated shopper API calls. Mirrors charms's
// shopperApi pattern (single fetch wrapper that pulls the bearer token
// from localStorage.userSession and prefixes the customer-scoped path).

const API_BASE    = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_STOREFRONT_API_URL) || 'https://dashboard.offloadhost.com';
const CUSTOMER_ID = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_CUSTOMER_ID) || '';

function getToken() {
  try {
    const raw = localStorage.getItem('userSession');
    if (!raw) return null;
    return JSON.parse(raw)?.token || null;
  } catch (_) { return null; }
}

export async function shopperApi(path, init = {}) {
  const token = getToken();
  const headers = { 'Accept': 'application/json', ...(init.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (init.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
  const r = await fetch(`${API_BASE}/storefront/${CUSTOMER_ID}/auth${path}`, { ...init, headers });
  let data = null;
  try { data = await r.json(); } catch (_) {}
  return { ok: r.ok, status: r.status, data };
}

export const apiGet    = (path)       => shopperApi(path, { method: 'GET' });
export const apiPost   = (path, body) => shopperApi(path, { method: 'POST', body: JSON.stringify(body || {}) });
